import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { updateFieldForm } from 'redux/actions/FormAction';
import { injectIntl } from 'react-intl';
import {
  createCheckout,
  requestPay,
  signatureAgreementTNC,
} from 'redux/actions/BillerAction';
import { trackEvent } from 'utils/Mixpanel';
import { setLoading, setErrorState } from 'redux/actions/GeneralAction';

import GenesisFormPage from './GenesisFormPage.page';

const page = injectIntl(GenesisFormPage);

export const mapStateToProps = state => ({
  isLoading: state.general.isLoading,
  deviceHeight: state.general.deviceHeight,
  biller: state.biller.biller,
  userAgreements: state.biller.userAgreements,
  prefix: state.biller.prefixList,
  checkout: state.biller.checkout,
  formData: state.formData.form,
  formValue: state.formData.formValue,
  reduxFormValue: getFormValues('allBiller')(state),
  additionalInfo: state.general.additionalInfo,
});

const mapDispatchToProps = {
  createCheckout,
  requestPay,
  updateFieldForm,
  trackEvent,
  setLoading,
  setErrorState,
  signatureAgreementTNC,
};

export default reduxForm({
  form: 'amountGenesis',
})(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(page),
);
